import { render, staticRenderFns } from "./mainNav.vue?vue&type=template&id=2a08902e&"
import script from "./mainNav.vue?vue&type=script&lang=js&"
export * from "./mainNav.vue?vue&type=script&lang=js&"
import style0 from "./mainNav.vue?vue&type=style&index=0&id=2a08902e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports